import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { faExternalLinkAlt } from '@/lib/fontAwesomePro/light'
import { toSafeHttpUrl } from '@/lib/helpers/helperFunctions'
import { cn } from '@/lib/utils'

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'target'> & {
  iconPlacement?: 'start' | 'end'
}

// Often given company-entered links, so only http(s) (or relative) hrefs are
// kept: a `javascript:` href is dropped rather than run in the viewer's session.
const ExternalLink: React.FC<Props> = ({
  children,
  href,
  rel = 'noreferrer',
  className,
  iconPlacement = 'end',
  ...props
}) => (
  // rel defaults to 'noreferrer'; the rule can't see that through the prop.
  // eslint-disable-next-line react/jsx-no-target-blank
  <a
    {...props}
    href={toSafeHttpUrl(href, window.location.href) ?? undefined}
    rel={rel}
    target="_blank"
    className={cn('inline-flex items-center justify-center gap-1', className)}
  >
    {iconPlacement === 'start' && (
      <FontAwesomeIcon icon={faExternalLinkAlt} className="text-xs" />
    )}

    <div>{children}</div>

    {iconPlacement === 'end' && (
      <FontAwesomeIcon icon={faExternalLinkAlt} className="text-xs" />
    )}
  </a>
)

export default ExternalLink
